import { render, staticRenderFns } from "./EstablishmentViewCafeterias.vue?vue&type=template&id=2efa2318"
import script from "./EstablishmentViewCafeterias.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewCafeterias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports